import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dialer-report',
  templateUrl: './dialer-report.component.html',
  styleUrls: ['./dialer-report.component.scss']
})
export class DialerReportComponent implements OnInit {

  @Input() dialerreport:string[];
  @Output() active: EventEmitter<number> = new EventEmitter();
 
  constructor() {}

  ngOnInit() {
  }

  OnClick(type:number)
  {
    console.log("Current event : "+type);   
    this.active.emit(type);  
  }

}

